import React from 'react';
import displayName from 'component-lib/displayName';

import TableView from './TableView';
import TablePositionBase from './TablePositionBase';

import styles from './Table.scss';

const { cellPositions } = TableView;

export default class TableBody extends TablePositionBase {
    static displayName = displayName('TableView/TableBody');

    static defaultProps = {
        ...TablePositionBase.defaultProps,
        componentClass: 'table-body',
        position: cellPositions.BODY,
    };

    renderBody(props) {
        const { children, componentClass } = this.props;

        return (
            <tbody className={styles[componentClass]} {...props}>
                {children}
            </tbody>
        );
    }
}
